import { enhancedApi as generatedUserApi } from './user'
import { userCacheTags } from './userCacheTags'

// The generator emits no cache tags, so they are applied here rather than patched into
// `user.ts`, which the next `pnpm api-generate` would wipe. Import hooks from this module,
// never from `./user`, or a chunk that skips this file ships without the tags.

// Each policy key maps onto itself only when it names a generated endpoint, so a regeneration
// rename fails compilation here instead of enhanceEndpoints silently ignoring the policy.
const checkedCacheTags: {
  [K in keyof typeof userCacheTags]: K extends keyof (typeof generatedUserApi)['endpoints']
    ? (typeof userCacheTags)[K]
    : never
} = userCacheTags

export const usersApi = generatedUserApi.enhanceEndpoints({ endpoints: checkedCacheTags })

export const {
  useListTenantUsersQuery,
  useListArchivedUsersQuery,
  useCreateUserMutation,
  useArchiveUserMutation,
  useImportUsersMutation,
  useArchiveUsersMutation,
  useUnarchiveUsersMutation,
  useDeleteArchivedUsersMutation,
  useUnlinkIdentityProvidersMutation,
  useListIdentityLinksQuery,
  useInviteUsersMutation,
  useUpdateUserMutation,
  useUpdateUserStatusMutation,
  useCreateOrUpgradeGlobalAdminMutation,
  useAssignUsersToUnitsMutation,
  useUnassignUsersFromUnitsMutation,
  useBulkUnassignUsersFromUnitsMutation,
  useListUserDismissalsQuery,
  useDismissUserNoticeMutation,
} = usersApi
export * from './user'
